<h2 mat-dialog-title>🚀 Hangfire Job Manager</h2>

<mat-dialog-content>
  <h3>Create a Hangfire Job</h3>

  <form (ngSubmit)="createJob()">
    <label for="jobName">Job Name:</label>
    <input type="text" id="jobName" [(ngModel)]="jobName" name="jobName" required>

    <label for="jobTask">Select Task:</label>
    <ejs-combobox id="jobTask"
                  [dataSource]="taskOptions"
                  placeholder="Select Task"
                  [(ngModel)]="selectedTask"
                  name="jobTask">
    </ejs-combobox>

    <label for="cronExpression">Job Frequency:</label>
    <ejs-combobox id="cronExpression"
                  [dataSource]="frequencyOptions"
                  placeholder="Select Frequency"
                  [(ngModel)]="selectedFrequency"
                  name="cronExpression"
                  [fields]="{ text: 'label', value: 'value' }">
    </ejs-combobox>

    <label for="email">Email Notification:</label>
    <input type="email" id="email" [(ngModel)]="email" name="email">

    <button type="submit">Create Job</button>
  </form>

  <h3>Delete a Job</h3>
  <form (ngSubmit)="deleteJob()">
    <label for="deleteJobName">Job Name:</label>
    <input type="text" id="deleteJobName" [(ngModel)]="deleteJobName" name="deleteJobName" required>

    <button type="submit" class="delete-btn">Delete Job</button>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="closeModal()">Close</button>
</mat-dialog-actions>
